<script setup>
const props = defineProps({
  number: {
    type: [String, Number],
    default: ''
  },
  hideNumber: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <h3 class="flex items-center gap-4 font-semibold mb-10">
    <span
        v-if="!hideNumber"
        class="h-10 w-10 lg:h-12 lg:w-12 bg-dark text-2xlx lg:text-3xl text-light rounded-full inline-flex justify-center items-center leading-none"
    >
      <span class="relative -mt-[4px]" v-text="props.number"></span>
    </span>
    <span class="text-2xlx lg:text-3xl leading-none">
      <slot></slot>
    </span>
  </h3>
</template>